import React, { memo, useMemo } from 'react'
import { Space } from 'antd'
import { VStack } from '../../../../../../ui/Stack'
import { formatDate } from '../../../../activity-timeline/hooks/useFormatDate'
import { StagePlanItemI } from '../../../model/types/types'

export const StagePlanItemDefault: React.FC<StagePlanItemI & { responsibleLabel?: string }> = memo((props) => {
  const {
      date_end,
      date_start,
      name,
      responsible,
      organization,
      responsibleLabel = 'Ответственный',
  } = props
  const formatDateStart = useMemo<string>(
    () => formatDate(date_start),
    [date_start],
  )

  const formatDateEnd = useMemo<string>(
    () => formatDate(date_end),
    [date_end],
  )

  return (
    <VStack align={"start"} style={{ paddingBottom: '16px' }}>
      <Space size={4}>
        <span style={{ fontWeight: 'bold' }}>
            {name}{formatDateEnd && `, ${formatDateEnd}`}
        </span>
      </Space>
      {formatDateStart && <Space size={4}>
        <span>Дата (начала):</span> {formatDateStart}
      </Space>}

      {responsible && <Space size={4}>
        {`${responsibleLabel}:`}
        <span style={{ color: '#a8adb4'}}>{responsible}</span> {organization}
      </Space>}
    </VStack>
  )
})
